import React from 'react';
import { CheckCircle2, ShieldCheck, FlaskConical, Globe2, Award, Clock, Search, HelpCircle, Leaf, Thermometer, AlertTriangle, FileCheck, Factory, Microscope, Users, History, ExternalLink } from 'lucide-react';
export function WhyChoosePage() {
  return <div className="bg-white min-h-screen pb-20" data-id="element-712">
      {/* Page Header */}
      <div className="bg-gray-50 border-b border-gray-200 py-16 px-4 sm:px-6 lg:px-8" data-id="element-713">
        <div className="max-w-4xl mx-auto text-center" data-id="element-714">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-715">
            <Award className="w-10 h-10 text-[#0e7be1]" data-id="element-716" />
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900" data-id="element-717">
              Why Choose NeoLife?
            </h1>
          </div>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mt-4" data-id="element-718">
            Discover the difference of science-backed nutrition and quality
            without compromise.
          </p>
          <div className="w-24 h-1 bg-[#0e7be1] mx-auto rounded-full mt-8" data-id="element-719"></div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-20" data-id="element-720">
        {/* Video Section */}
        <section data-id="element-721">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-722">
            See The Difference
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-723">
            <div className="space-y-4" data-id="element-724">
              <div className="relative w-full aspect-video rounded-xl overflow-hidden shadow-lg bg-black border border-gray-100" data-id="element-725">
                <iframe className="absolute top-0 left-0 w-full h-full" src="https://www.youtube.com/embed/bm4WQs2SsLk?wmode=opaque" title="Why take vitamins" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-726"></iframe>
              </div>
              <h3 className="text-lg font-bold text-gray-900 leading-tight" data-id="element-727">
                Why everyone should take vitamins and supplements
              </h3>
            </div>

            <div className="space-y-4" data-id="element-728">
              <div className="relative w-full aspect-video rounded-xl overflow-hidden shadow-lg bg-black border border-gray-100" data-id="element-729">
                <iframe className="absolute top-0 left-0 w-full h-full" src="https://www.youtube.com/embed/dnfmU2VeDTU?wmode=opaque" title="How to choose vitamins" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-730"></iframe>
              </div>
              <h3 className="text-lg font-bold text-gray-900 leading-tight" data-id="element-731">
                How to choose vitamins and supplements
              </h3>
            </div>

            <div className="space-y-4" data-id="element-732">
              <div className="relative w-full aspect-video rounded-xl overflow-hidden shadow-lg bg-black border border-gray-100" data-id="element-733">
                <iframe className="absolute top-0 left-0 w-full h-full" src="https://www.youtube.com/embed/zwtRBplwSGA?wmode=opaque" title="Trust GNLD NeoLife" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-734"></iframe>
              </div>
              <h3 className="text-lg font-bold text-gray-900 leading-tight" data-id="element-735">
                Why you can trust GNLD NeoLife
              </h3>
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-736">
            <a href="http://shopneolife.com/lookfeelbetter/enrollment/enrollmentconfiguration" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-[#1a8f3c] hover:bg-[#157a32] text-white text-lg font-bold px-8 py-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 transform hover:-translate-y-0.5" data-id="element-737">
              Click here to Join the club and save up to 25%!
              <ExternalLink className="w-5 h-5" data-id="element-738" />
            </a>
          </div>
        </section>

        {/* Criteria Section */}
        <section className="bg-blue-50 rounded-3xl p-8 md:p-12 border border-blue-100" data-id="element-739">
          <div className="max-w-4xl mx-auto" data-id="element-740">
            <h2 className="text-3xl font-bold text-gray-900 mb-10 text-center" data-id="element-741">
              Criteria For Choosing A Vitamin Company
            </h2>
            <div className="grid gap-8" data-id="element-742">
              {[{
              question: 'Does the company manufacture their own products in their own dedicated facility?',
              answer: 'If it is in a shared facility there is risk for cross contamination.',
              icon: Factory
            }, {
              question: 'Is the facility FDA licensed?',
              answer: 'An FDA licensed facility is open to unannounced 24-hour inspections, and the products that are produced must contain 100% of the stated ingredients because it is treated as a pharmaceutical. If they are not FDA licensed they are only required to have 20% under Good Manufacturing Practices.',
              icon: FileCheck
            }, {
              question: 'Where are the ingredients sourced from?',
              answer: 'China controls 90% of the raw ingredient market for supplementation! They do not have the same guidelines we do for food quality and proper transportation.',
              icon: Globe2
            }, {
              question: 'Does the company have true, human clinical data published in competent peer reviewed journals?',
              answer: 'Many supplement companies “piggyback” nutritional data from other sources, or run with the latest fad.',
              icon: FlaskConical
            }, {
              question: 'Does the company have their own scientific staff & are they Ph.D. trained & published?',
              answer: 'Many companies have Doctors that are paid spokesmen and not involved in research for the company.',
              icon: Users
            }, {
              question: 'How long does it take to bring a product to market?',
              answer: 'Supplement companies are quick to jump on the bandwagon. A company should carefully research, and test their products.',
              icon: Clock
            }, {
              question: "Google the company's name with the following criteria:",
              answer: 'Lawsuit, death by, fraud, misrepresentation, scam, bribery, product recall, FDA complaint.',
              icon: Search
            }].map((item, idx) => <div key={idx} className="bg-white p-6 rounded-xl shadow-sm border border-blue-100 flex gap-4 md:gap-6" data-id="element-743">
                  <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center text-[#0e7be1]" data-id="element-744">
                    <item.icon className="w-6 h-6" data-id="element-745" />
                  </div>
                  <div data-id="element-746">
                    <h3 className="text-lg font-bold text-gray-900 mb-2 uppercase text-sm tracking-wide" data-id="element-747">
                      {item.question}
                    </h3>
                    <p className="text-gray-700 leading-relaxed" data-id="element-748">
                      {item.answer}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* 10 Reasons Section */}
        <section data-id="element-749">
          <div className="text-center mb-12" data-id="element-750">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-751">
              10 GNLD NeoLife Differences
            </h2>
            <p className="text-xl text-gray-600" data-id="element-752">
              Reasons they're the best for health
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-753">
            {[{
            title: 'Quality is Not a Goal — It’s a Commitment',
            desc: 'GNLD does not define quality as a high standard to be achieved. Instead, it is a level of excellence which our people and products have already attained and that we are committed to maintaining.',
            num: 1
          }, {
            title: 'A “What’s Right” Philosophy',
            desc: 'Every decision is made in the best interests of the CUSTOMER, DISTRIBUTOR, COMPANY, and the ENVIRONMENT. This philosophy ensures that each product will be of the finest quality.',
            num: 2
          }, {
            title: 'Based in Nature, Backed by Science',
            desc: 'We use nature as a “blueprint” to formulate products that are safe and effective. We combine the best that Nature and Science have to offer to create innovative products.',
            num: 3
          }, {
            title: 'Our SAB is Enormously Talented',
            desc: 'GNLD’s Scientific Advisory Board is the most active, committed, prominent, and qualified in the nutrition industry. They are continuously involved in hundreds of research projects.',
            num: 4
          }, {
            title: 'Raw Materials Up to a Standard',
            desc: 'We select only the finest raw materials to ensure quality results. We are renowned for manufacturing products that are “up to a standard, not down to a price.”',
            num: 5
          }, {
            title: 'We Don’t Take Their Word — We Test It!',
            desc: 'GNLD verifies the quality of each raw material. We test for potency, purity, disintegration, dissolution, stability, bioavailability, odor, and taste.',
            num: 6
          }, {
            title: 'Highest Manufacturing Standards',
            desc: 'Our U.S. manufacturing facility holds a Drug Manufacturing License. We voluntarily subject ourselves to scrutiny to assure the finest quality products.',
            num: 7
          }, {
            title: 'State-of-the-Art R&D Facilities',
            desc: 'Our North American Research Facility and European Technology Center house high-technology instruments that allow us to develop safe, effective products.',
            num: 8
          }, {
            title: 'Highly Skilled Technical People',
            desc: 'GNLD employs a highly skilled team of laboratory specialists responsible for quality control and assurance, using sophisticated instruments.',
            num: 9
          }, {
            title: 'Longevity and Leadership',
            desc: 'In business since 1958, GNLD is an industry leader that other companies try to imitate. Our reputation is based on a history teeming with technical achievements.',
            num: 10
          }].map(reason => <div key={reason.num} className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-md transition-shadow duration-200" data-id="element-754">
                <div className="flex items-center gap-3 mb-3" data-id="element-755">
                  <span className="flex-shrink-0 w-8 h-8 bg-[#0e7be1] text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-756">
                    #{reason.num}
                  </span>
                  <h3 className="text-lg font-bold text-gray-900" data-id="element-757">
                    {reason.title}
                  </h3>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed pl-11" data-id="element-758">
                  {reason.desc}
                </p>
              </div>)}
          </div>
        </section>

        {/* FAQ Section */}
        <section className="max-w-4xl mx-auto" data-id="element-759">
          <div className="flex items-center justify-center gap-3 mb-10" data-id="element-760">
            <HelpCircle className="w-8 h-8 text-[#0e7be1]" data-id="element-761" />
            <h2 className="text-3xl font-bold text-gray-900" data-id="element-762">Product FAQs</h2>
          </div>

          <div className="space-y-8" data-id="element-763">
            {[{
            q: 'Where do the colors for our tablets and capsules come from?',
            a: 'GNLD does not use artificial colorings! Our tablets and capsules obtain their rich colors from natural sources contained in the individual products.',
            icon: Leaf
          }, {
            q: 'Which GNLD Neolife products contain artificial flavors?',
            a: 'Only three product groups contain artificial flavors: NouriShake®, Super Ease®, and GR2 Control®. For all other products, we look first to nature for 100% natural flavors.',
            icon: FlaskConical
          }, {
            q: 'Do GNLD products contain MSG?',
            a: 'We do not add monosodium glutamate (MSG) to any GNLD product. The SAB could not, in good conscience, allow MSG to be added to any GNLD product.',
            icon: AlertTriangle
          }, {
            q: 'Does GNLD Neolife use any genetically modified components?',
            a: 'No. We set raw material standards that demanded all ingredients of plant or animal origin be free from genetic modification. You can confidently use GNLD products knowing they do not contain GMOs.',
            icon: ShieldCheck
          }, {
            q: 'Are GNLD products or ingredients organic?',
            a: 'While we do not use strictly organically grown materials, we use only the best raw materials available. We test every raw material to make sure all ingredients are pesticide-free.',
            icon: CheckCircle2
          }, {
            q: 'At what temperature are products processed?',
            a: 'Our products are processed with as little heat and moisture as possible to maximize nutrient content. We test finished products to insure the full nutrient spectrum is present.',
            icon: Thermometer
          }, {
            q: 'Could unfamiliar ingredients be harmful?',
            a: 'We assure you that ALL ingredients we use are perfectly safe and have a long history of safe use. The SAB would never allow a questionable ingredient to be used.',
            icon: Search
          }, {
            q: 'What about cancer and chemotherapy?',
            a: 'During chemotherapy, it is wise not to take most supplements, especially B-Complex. An exception many doctors allow is Daily Carotenoid Complex™ and Daily Flavonoid Complex™. Always consult your physician.',
            icon: ActivityIcon
          }, {
            q: "What is GNLD USA's Pharmaceutical License Number?",
            a: 'Natural Formulas maintains Drug Manufacturing License #40708 issued by the State of California. This means our products are made to pharmaceutical standards and we adhere to Good Manufacturing Practices (GMPs).',
            icon: FileCheck
          }].map((faq, idx) => <div key={idx} className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-764">
                <div className="flex gap-4" data-id="element-765">
                  <div className="flex-shrink-0 mt-1" data-id="element-766">
                    <faq.icon className="w-6 h-6 text-[#0e7be1]" data-id="element-767" />
                  </div>
                  <div data-id="element-768">
                    <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-769">
                      {faq.q}
                    </h3>
                    <p className="text-gray-700 leading-relaxed" data-id="element-770">{faq.a}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </section>

        {/* Final CTA */}
        <div className="bg-gray-900 rounded-3xl p-8 md:p-16 text-center text-white overflow-hidden relative" data-id="element-771">
          <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-772"></div>
          <div className="relative z-10" data-id="element-773">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-774">
              Count on GNLD NeoLife
            </h2>
            <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-775">
              For products you can trust and a business built to last. We are
              totally committed to remaining at the leading edge of product
              innovation.
            </p>
            <a href="http://shopneolife.com/lookfeelbetter/enrollment/enrollmentconfiguration" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-[#0e7be1] hover:bg-[#0c6bc4] text-white text-lg md:text-xl font-bold px-10 py-5 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 transform hover:-translate-y-0.5" data-id="element-776">
              Start Your Journey Today
              <ExternalLink className="w-5 h-5" data-id="element-777" />
            </a>
          </div>
        </div>
      </div>
    </div>;
}
function ActivityIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-778">
      <path d="M22 12h-4l-3 9L9 3l-3 9H2" data-id="element-779" />
    </svg>;
}